import ProgramInfo from './programInfo';
import MyRoutine from './myRoutine';
import PastRoutine from './pastRoutine';
import Timer from '../common/timer';
import WorkoutTracker from '../common/workoutTracker';
import MealTracker from '../common/mealTracker';
import WeightProgress from '../common/weightProgress';
import BodyProgress from '../common/bodyProgress';
import MeasurementProgress from '../common/measurementProgress';
// import AICoach from './aiCoach';
// import OpenChat from '../common/openChat';
// import Application from '../common/application';

const Registered = ({ user, handleHubChange, openAiCoachDialog }) => {
  return (
    <div className='grid grid-cols-2 gap-3'>
      <ProgramInfo user={user} />
      <MyRoutine handleHubChange={handleHubChange} />
      <PastRoutine handleHubChange={handleHubChange} />
      <Timer handleHubChange={handleHubChange} />
      <WeightProgress handleHubChange={handleHubChange} />
      <BodyProgress handleHubChange={handleHubChange} />
      <MeasurementProgress handleHubChange={handleHubChange} />
      <WorkoutTracker />
      <MealTracker />
      {/* <AICoach openAiCoachDialog={openAiCoachDialog} /> */}
      {/* <OpenChat handleHubChange={handleHubChange} /> */}
      {/* <Application handleHubChange={handleHubChange} /> */}
    </div>
  );
};

export default Registered;
